import { useAuthMutation } from './auth'
import { ApiStudentRequest, request } from '../utils/request'

type DeleteApplicationParams = {
  id?: string
}

export function useDeleteApplication() {
  const { isPending, mutate } = useAuthMutation(async (params: DeleteApplicationParams) => {
    return await request(
      new ApiStudentRequest(`/applications/${params.id}`, {
        method: 'DELETE',
      }),
      {
        isExpectedResponse: (res): res is unknown => true,
      },
    )
  })

  return {
    isDeletingApplication: isPending,
    deleteApplication: mutate,
  }
}
